import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import navigationService from '../../services/navigationService';

/**
 * کامپوننت شنونده ناوبری
 * این کامپوننت callback های ناوبری را ثبت می‌کند تا ریدایرکت بدون رفرش صفحه انجام شود
 */
const NavigationListener: React.FC = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    console.log('NavigationListener mounted - registering callbacks');
    
    // ثبت callback ها
    navigationService.registerCallbacks(
      // ریدایرکت به مسیر دلخواه
      (path) => {
        console.log('NavigationListener: Redirecting to', path);
        navigate(path, { replace: true });
      },
      // ریدایرکت به صفحه لاگین
      () => {
        console.log('NavigationListener: Redirecting to login');
        navigate('/login', { replace: true });
      },
      // ریدایرکت به صفحه عدم دسترسی
      () => {
        console.log('NavigationListener: Redirecting to unauthorized');
        navigate('/unauthorized', { replace: true });
      }
    );
    
    // حذف callback ها هنگام unmount
    return () => {
      console.log('NavigationListener unmounted - unregistering callbacks');
      navigationService.unregisterCallbacks();
    };
  }, [navigate]);
  
  // این کامپوننت چیزی رندر نمی‌کند
  return null;
};

export default NavigationListener; 